// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__iv8Js","btnOffer":"AddProduct_btnOffer__-oDlX"};